/**Để biết gọi screen create card từ quy trình tạo account hay từ list card page */
export const createCardModeEnum = {
  createAccount: 1,
  listCard: 2
}